(function () {
  'use strict';
  if (window.PGHomePressMarqueeV12) return;
  window.PGHomePressMarqueeV12 = true;

  function installMarquee() {
    var strip = document.querySelector('.pg-press-strip');
    if (!strip || strip.dataset.pgWideMarqueeReady === 'true') return;
    var inner = strip.querySelector('.pg-press-inner');
    var track = strip.querySelector('.pg-press-logos');
    if (!inner || !track) return;

    strip.dataset.pgWideMarqueeReady = 'true';
    strip.dataset.pgMarqueeReady = 'true';
    track.classList.add('pg-press-marquee-track');

    var originals = Array.prototype.slice.call(track.children).filter(function (item) {
      return !item.classList.contains('pg-press-marquee-clone') && !item.classList.contains('pg-press-marquee-set');
    });
    if (!originals.length) return;

    track.innerHTML = '';
    var firstSet = document.createElement('div');
    firstSet.className = 'pg-press-marquee-set';
    var secondSet = document.createElement('div');
    secondSet.className = 'pg-press-marquee-set';
    secondSet.setAttribute('aria-hidden', 'true');

    originals.forEach(function (item) {
      firstSet.appendChild(item);
      var clone = item.cloneNode(true);
      clone.classList.add('pg-press-marquee-clone');
      clone.removeAttribute('id');
      clone.querySelectorAll('[id]').forEach(function (node) { node.removeAttribute('id'); });
      secondSet.appendChild(clone);
    });

    track.appendChild(firstSet);
    track.appendChild(secondSet);

    if (!strip.querySelector('.pg-press-marquee-title')) {
      var title = document.createElement('p');
      title.className = 'pg-press-marquee-title';
      title.textContent = 'As seen in';
      inner.parentNode.insertBefore(title, inner);
    }
  }

  function boot() {
    installMarquee();
    [100, 300, 800, 1600].forEach(function (delay) { window.setTimeout(installMarquee, delay); });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot, { once: true });
  else boot();
  document.addEventListener('shopify:section:load', function () { window.setTimeout(installMarquee, 0); });
})();
